<template>
	<div class="initial-proposal-table">
		<!-- <b-row class="d-flex align-items-center justify-content-md-between">
			<b-col cols="12" md="6" class="d-md-flex">
				<base-input v-model="searchQuery" prepend-icon="fas fa-search" placeholder="Search">
				</base-input>
			</b-col>
		</b-row> -->
		<b-row class="d-flex justify-content-end mb-3" >
			<b-button variant="outline-secondary" class="float-md-right mx-2" @click="$refs.filter_initial_proposal_drawer.viewFilterInitialProposal()">
				<b-icon icon="filter"></b-icon>
				Filter
			</b-button>
		</b-row>
		<div class="table-listings">
			<el-table ref="multipleTable" :data="proposalList" style="width: 100%" empty-text="No Data"
				@selection-change="selectionChange" v-loading="is_loading_table || is_loading">
				<el-table-column type="selection" min-width="55" fixed></el-table-column>

				<el-table-column
					label="Customer/ID" fixed min-width="280"
					prop="customer_detail.name"
					sortable>
					<template slot-scope="scope">
						<router-link event @click.native.prevent="$event => viewProposal(scope.row)"
							:to="'/initialProposalDetails/'+scope.row.psal_id">
							<p class="top-line text-primary font-weight-500 text-elipsis">{{ scope.row.customer_detail.name || 'N/A'}}</p>
						</router-link>
						<p class="bottom-line">{{ scope.row.psal_customer_id }} </p>
					</template>
				</el-table-column>

				<el-table-column width="55" class-name="text-center" fixed>
					<template slot-scope="scope">
						<svg
							v-b-tooltip.hover="checkIsCorporateSubscription() ? getBasketDescription(scope.row) : ''"
							xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="rounded"
							:style="{ 'background': getBasketColor(scope.row), 'padding': '0.125rem' }">
							<path fill="#fff"
								d="M21 9h-1.42l-3.712-6.496-1.736.992L17.277 9H6.723l3.146-5.504-1.737-.992L4.42 9H3a1.001 1.001 0 0 0-.965 1.263l2.799 10.264A2.005 2.005 0 0 0 6.764 22h10.473c.898 0 1.692-.605 1.93-1.475l2.799-10.263A.998.998 0 0 0 21 9zm-3.764 11v1-1H6.764L4.31 11h15.38l-2.454 9z" />
							<path fill="#fff" d="M9 13h2v5H9zm4 0h2v5h-2z" />
						</svg>
					</template>
				</el-table-column>

				<el-table-column v-if="auth_user.subscription.privileges.scpk_crm_chat_massage" fixed width="70"
					class-name="icons-chat">
					<template slot-scope="scope">
						<MessagingBoxButton :type="'proposal'" :profile="scope.row" />
					</template>
				</el-table-column>

				<el-table-column width="95" sortable class-name="text-center" prop="customer_detail.se_name">
					<template #header>
						<span>Lead Owner</span>
					</template>
					<template slot-scope="scope">
						<b-avatar size="32px" :text="formatInitials(scope.row.customer_detail.se_name)"
							v-b-tooltip.hover="scope.row.customer_detail.se_name" v-if="scope.row.customer_detail.se_name"></b-avatar>
						<span v-else>-</span>
					</template>
				</el-table-column>

				<el-table-column label="Product" min-width="300" sortable :sort-method="customProductSort">
					<template slot-scope="scope">
						<div v-if="_gHlp.getValue(scope,'row.product_applications',[]).length > 0">
							<div v-for="(product, index) in scope.row.product_applications" :key="index" class="text-capitalize mb-1">
								<el-tooltip placement="bottom" effect="dark">
									<div slot="content"
										v-if="['PROPERTY', 'MORTGAGE'].includes(product.pcom_product_detail.pcp_product_type)">
										<h4 class="mb-0 text-white">{{ product.pcom_product_detail.pcp_product_type }}</h4>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Project:</span> {{ product.pcom_product_detail.pcp_project_name ||
												'N/A' }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Unit No:</span> {{ product.pcom_product_detail.pcp_project_unit_no ||
												'N/A' }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Loan Amount:</span> RM{{ product.pcom_product_detail.pcp_loan_amount
												| moneyFormatter }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Bank:</span> {{ product.pcom_bank_name }} ({{
												product.pcom_product_detail.pcp_interest_rate }}%)
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Monthly Installment:</span> RM{{
												product.pcom_product_detail.pcp_monthly_installment | moneyFormatter }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Tenure:</span> {{ product.pcom_product_detail.pcp_tenure }} Years
										</p>
									</div>
									<div slot="content" v-if="product.pcom_product_detail.pcp_product_type === 'PERSONAL_LOAN'">
										<h4 class="mb-0 text-white">PERSONAL LOAN</h4>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Loan Amount:</span> RM{{ product.pcom_product_detail.pcp_loan_amount
												| moneyFormatter }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Bank:</span> {{ product.pcom_bank_name }} ({{
												product.pcom_product_detail.pcp_interest_rate }}%)
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Monthly Installment:</span> RM{{
												product.pcom_product_detail.pcp_monthly_installment | moneyFormatter }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Tenure:</span> {{ product.pcom_product_detail.pcp_tenure }} Years
										</p>
									</div>
									<div slot="content" v-if="product.pcom_product_detail.pcp_product_type === 'OTHER'">
										<h4 class="mb-0 text-white">OTHER</h4>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Product:</span> {{
												product.pcom_product_detail.pcp_project_json.prod_oth_type }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Product Detail:</span> {{
												product.pcom_product_detail.pcp_project_json.prod_oth_detail }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Product Value:</span> RM{{
												product.pcom_product_detail.pcp_project_json.prod_oth_value | moneyFormatter }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Payment Mode:</span> {{
												product.pcom_product_detail.pcp_project_json.prod_oth_pay_mode }}
										</p>
									</div>
									<div slot="content" v-if="product.pcom_product_detail.pcp_product_type === 'INSURANCE'">
										<h4 class="mb-0 text-white">INSURANCE</h4>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Package:</span> {{
												product.pcom_product_detail.pcp_project_json.prod_ins_package }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Company:</span> {{
												product.pcom_product_detail.pcp_project_json.prod_ins_company }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Premium p.a:</span> RM{{
												product.pcom_product_detail.pcp_project_json.prod_ins_premium_pa | moneyFormatter }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Premium p.m:</span> RM{{
												product.pcom_product_detail.pcp_project_json.prod_ins_premium_pm | moneyFormatter }}
										</p>
										<p class="bottom-line text-white">
											<span class="font-weight-bold">Paid By:</span> {{
												product.pcom_product_detail.pcp_project_json.prod_ins_paid_by }}
										</p>
									</div>
									<b-icon icon="info-circle-fill" class="mr-2"></b-icon>
								</el-tooltip>
								<span class="mr-1 font-weight-bold">{{ (product.pcom_product_detail.pcp_product_type).replace('_', ' ').toLowerCase() }}:</span>
								<span v-if="product.pcom_product_detail.pcp_product_type === 'INSURANCE'">RM{{
									product.pcom_product_detail.pcp_project_json.prod_ins_premium_pa | moneyFormatter }}</span>
								<span v-else-if="product.pcom_product_detail.pcp_product_type === 'OTHER'">RM{{
									product.pcom_product_detail.pcp_project_json.prod_oth_value | moneyFormatter }}</span>
								<span v-else>RM{{ product.pcom_product_detail.pcp_loan_amount | moneyFormatter }}</span>
							</div>
						</div>
						<span v-else>-</span>
					</template>
				</el-table-column>

				<el-table-column width="90" sortable prop="customer_detail.ssa_name">
					<template #header>
						<span>SSA</span>
					</template>
					<template slot-scope="scope">
						<b-avatar :id="'target-'+scope.row.psal_id" size="32px" :text="formatInitials(scope.row.customer_detail.ssa_name)" :class="generateSsaColor(scope.row.psal_approval_code, scope.row.psal_main_status)"
							v-if="scope.row.customer_detail.ssa_name"></b-avatar>
						<span v-else>-</span>
						<b-tooltip :target="'target-'+scope.row.psal_id" triggers="hover">
							{{ scope.row.customer_detail.ssa_name }} <br />
							Submitted at : {{ !_gHlp.isEmpty(scope.row.psal_submited_ssa_date) ? scope.row.psal_submited_ssa_date : "-" }}
						</b-tooltip>
					</template>
				</el-table-column>

				<el-table-column width="90" sortable class-name="text-center" prop="psal_approved_ssa_by_detail.name" :sort-method="customSsaMgrSort">
					<template #header>
						<span>SSA MGR</span>
					</template>
					<template slot-scope="scope">
						<b-avatar :id="'ssa_mgr-'+scope.row.psal_id" size="32px" :text="formatInitials(scope.row.psal_approved_ssa_by_detail.name)" :class="generateSsaMgrColor(scope.row.psal_approval_code, scope.row.psal_main_status)"
							v-if="scope.row.psal_approved_ssa_by_detail"></b-avatar>
						<span v-else>-</span>
						<b-tooltip :target="'ssa_mgr-'+scope.row.psal_id" triggers="hover" v-if="scope.row.psal_approved_ssa_by_detail">
							{{ scope.row.psal_approved_ssa_by_detail.name }} <br />
							Approved at : {{ !_gHlp.isEmpty(scope.row.psal_submited_ch_date) ? scope.row.psal_submited_ch_date : (!_gHlp.isEmpty(scope.row.psal_submited_cc_date) ? scope.row.psal_submited_cc_date : "-") }}
						</b-tooltip>
					</template>
				</el-table-column>

				<el-table-column label="Credit MGR" min-width="95" class-name="text-center" sortable prop="psal_approved_cc_by_detail.name" :sort-method="customCreditMgrSort">
					<template slot-scope="scope">
						<b-avatar :id="'cc_mgr-'+scope.row.psal_id" size="32px" :text="formatInitials(scope.row.psal_approved_cc_by_detail.name)" :class="generateCreditMgrColor(scope.row.psal_approval_code, scope.row.psal_main_status)"
							v-if="scope.row.psal_approved_cc_by_detail"></b-avatar>
						<span v-else>-</span>
						<b-tooltip :target="'cc_mgr-'+scope.row.psal_id" triggers="hover" v-if="scope.row.psal_approved_cc_by_detail">
							{{ scope.row.psal_approved_cc_by_detail.name }} <br />
							Approved at : {{ !_gHlp.isEmpty(scope.row.psal_submited_pa_date) ? scope.row.psal_submited_pa_date : "-" }}
						</b-tooltip>
					</template>
				</el-table-column>

				<el-table-column width="95" sortable class-name="text-center" prop="psal_approved_ch_by_detail.name" :sort-method="customCreditHeadSort">
					<template #header>
						<span>Credit Head</span>
					</template>
					<template slot-scope="scope">
						<b-avatar :id="'cc_head-'+scope.row.psal_id" size="32px" :text="formatInitials(scope.row.psal_approved_ch_by_detail.name)" :class="generateCreditHeadColor(scope.row.psal_approval_code, scope.row.psal_main_status)"
							v-if="scope.row.psal_approved_ch_by_detail"></b-avatar>
						<span v-else>-</span>
						<b-tooltip :target="'cc_head-'+scope.row.psal_id" triggers="hover" v-if="scope.row.psal_approved_ch_by_detail">
							{{ scope.row.psal_approved_ch_by_detail.name }} <br />
							Approved at : {{ !_gHlp.isEmpty(scope.row.psal_submited_pa_date) ? scope.row.psal_submited_pa_date : "-" }}
						</b-tooltip>
					</template>
				</el-table-column>

				<el-table-column
					width="150"
					sortable
					prop="customer_detail.name"
					:sort-method="customCustomerSort"
					>
					<template #header>
						<div class="w-100">
							<span class="text-center">Customer</span>
						</div>
					</template>
					<!-- <template slot-scope="scope">
						<b-avatar size="32px" :text="formatInitials(scope.row.customer_detail.name)"
							v-b-tooltip.hover="scope.row.customer_detail.name" v-if="scope.row.customer_detail"></b-avatar>
						<span v-else>-</span>
					</template> -->
					<template slot-scope="scope">
						<div class="text-center">
							<b-avatar :id="'customerTarget-'+scope.row.psal_id" size="32px" :text="formatInitials(scope.row.customer_detail.name)" :class="generateCustomerColor(scope.row.psal_main_status)"
								v-if="scope.row.customer_detail.name"></b-avatar>
							<span v-else>-</span>
							<b-tooltip :target="'customerTarget-'+scope.row.psal_id" triggers="hover">
								{{ scope.row.customer_detail.name }} <br />
								Updated at : {{ scope.row.psal_client_accepted_date ? (scope.row.psal_client_accepted_date ) : "-" }}
							</b-tooltip>
						</div>
					</template>
				</el-table-column>

				<el-table-column label="Settlement" min-width="180" sortable prop="summary_ccris_track.total_inv_settlement" :sort-method="customSettlementSort">
					<template slot-scope="scope">
						<span class="font-weight-500 mb-2">RM{{ (
							parseFloat(scope.row.summary_ccris_track.total_inv_settlement) +
							parseFloat(scope.row.summary_ccris_track.total_merchant_settlement) +
							parseFloat(scope.row.summary_ccris_track.total_other_settlement)
						) | moneyFormatter }}</span>
						<el-tooltip placement="bottom" effect="dark">
							<div slot="content">
								<h4 class="text-white">Settlement Strategy</h4>
								<p class="bottom-line text-white">
									<span class="font-weight-500">Merchant:</span>
									RM{{ scope.row.summary_ccris_track.total_merchant_settlement | moneyFormatter }}
								</p>
								<p class="bottom-line text-white">
									<span class="font-weight-500">Credit Loan:</span>
									RM{{ scope.row.summary_ccris_track.total_inv_settlement | moneyFormatter }}
								</p>
								<p class="bottom-line text-white">
									<span class="font-weight-500">Other:</span>
									RM{{ scope.row.summary_ccris_track.total_other_settlement | moneyFormatter }}
								</p>
							</div>
							<b-icon icon="info-circle-fill" class="mr-2"></b-icon>
						</el-tooltip>
					</template>
				</el-table-column>

				<el-table-column width="90" sortable prop="psal_invinity_id">
					<template #header>
						<span>LMS</span>
					</template>
					<template slot-scope="scope">
							<b-icon icon="check-circle-fill" :variant="!_gHlp.isEmpty(scope.row.psal_invinity_id) ? 'success' : 'light'"
								font-scale="1.5" class="mx-2"
								v-b-tooltip.hover="!_gHlp.isEmpty(scope.row.psal_invinity_id) ? 'Submitted to Credit Approval' : 'Not Submitted to Credit Approval'"></b-icon>
					</template>
				</el-table-column>

				<el-table-column width="150" sortable prop="psal_main_status">
					<template #header>
						<span>Status</span>
					</template>
					<template slot-scope="scope">
						<span v-if="scope.row.psal_main_status" class="font-weight-bold">
							{{ scope.row.psal_main_status }}
						</span>
						<span v-else>-</span>
					</template>
				</el-table-column>

				<el-table-column width="115" sortable prop="psal_created_by_detail.name" class-name="text-center" :sort-method="customCreatedBySort">
					<template #header>
						<span>Created By</span>
					</template>
					<template slot-scope="scope">
						<b-avatar size="32px" :text="formatInitials(scope.row.psal_created_by_detail.name)"
							v-b-tooltip.hover="scope.row.psal_created_by_detail.name" v-if="scope.row.psal_created_by_detail.name"></b-avatar>
						<span v-else>-</span>
					</template>
					<template slot-scope="scope">
						<b-avatar :id="'createdBy-'+scope.row.psal_id" size="32px" :text="formatInitials(scope.row.psal_created_by_detail.name)"
							v-if="scope.row.psal_created_by_detail.name"></b-avatar>
						<span v-else>-</span>
						<b-tooltip :target="'createdBy-'+scope.row.psal_id" triggers="hover" v-if="scope.row.psal_created_by_detail">
							{{ scope.row.psal_created_by_detail.name }} <br />
							Created at : {{ scope.row.psal_created_date | dateTimeFormatString }}
						</b-tooltip>
					</template>
				</el-table-column>

				<el-table-column width="110" sortable class-name="text-center" prop="psal_updated_date">
					<template #header>
						<span>Last<br> Update</span>
					</template>
					<template slot-scope="scope">
						<span class="font-weight-bold">{{ scope.row.psal_updated_date | dateFormatString }}<br>{{ scope.row.psal_updated_date | timeFormatString }}</span>
					</template>
				</el-table-column>

				<el-table-column width="130" class-name="text-center" sortable :sort-method="customTatSort" prop="tat_summary.tat_total">
					<template #header>
						<span class="text-center w-100">TAT</span>
					</template>
					<template slot-scope="scope">
						<el-popover v-if="!isEmpty(scope.row.tat_summary) && !isEmpty(scope.row.tat_summary.tat_at)"
							placement="top-start" title="Date Tracking" trigger="hover">
							<p v-if="isEmpty(scope.row.tat_summary.tat_stop_at)">
								<small class="mb-0 d-block">Last Update : {{ scope.row.tat_summary.tat_at | dateFormatString }}</small>
								<small class="mb-0 d-block" :style="{ 'color': scope.row.tat_summary.tat_color }">Due Date :
									{{ scope.row.tat_summary.due_at | dateFormatString }}</small>
								<small class="mb-0 d-block" :style="{ 'color': scope.row.tat_summary.tat_color }">{{
									scope.row.tat_summary.remain_label }}</small>
							</p>
							<p v-else>
								<small class="mb-0 d-block">Create Date : {{ scope.row.tat_summary.tat_created_at |
									dateFormatString }}</small>
								<small class="mb-0 d-block">Stop Date : {{ scope.row.tat_summary.tat_stop_at | dateFormatString }}</small>
								<small class="mb-0 d-block"><strong>TOTAL : {{ scope.row.tat_summary.tat_total }} Days</strong></small>
							</p>
							<b-avatar :style="{ 'background-color': scope.row.tat_summary.tat_color, 'color': 'black' }" size="32px"
								slot="reference">{{ isEmpty(scope.row.tat_summary.tat_stop_at) ? scope.row.tat_summary.remain_day :
									scope.row.tat_summary.tat_total }}</b-avatar>
						</el-popover>
					</template>
				</el-table-column>

				<el-table-column
                        fixed="right"
                    >
                        <template slot-scope="scope">
                            <el-dropdown trigger="click"  style="cursor: pointer">
                                <p class="el-dropdown-link mb-0 top-line">
                                    <b-icon icon="three-dots-vertical"></b-icon>
                                </p>
                                <el-dropdown-menu slot="dropdown">
									<el-dropdown-item class="text-danger" @click.native="deleteProposal(scope.row.psal_id)">Delete</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>


				<!-- 
				<el-table-column label="Acceptance Date" min-width="180">
					<template slot-scope="scope">
						<span v-if="scope.row.psal_client_accepted_date">{{ scope.row.psal_client_accepted_date | dateFormatString
						}}</span>
						<span v-else>-</span>
					</template>
				</el-table-column> 

				<el-table-column label="Status" min-width="250">
					<template slot-scope="scope">
						<span v-if="scope.row.psal_main_status">{{ scope.row.psal_main_status }}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>

				

				<el-table-column label="Created By" min-width="150" class-name="text-center">
					<template slot-scope="scope">
						<b-avatar size="32px" :text="formatInitials(scope.row.psal_created_by_detail.name)"
							v-b-tooltip.hover="scope.row.psal_created_by_detail.name"
							v-if="scope.row.psal_created_by_detail"></b-avatar>
						<span v-else>-</span>
					</template>
				</el-table-column> -->

			</el-table>
		</div>
		<div slot="footer" class="mt-4 col-12 d-flex justify-content-center justify-content-md-between flex-wrap">
			<div class="d-flex align-items-center mb-3">
				<p class="card-category mb-0 text-secondary">
					Showing {{ proposalPagination.from }} to {{ proposalPagination.to }} of {{ proposalPagination.total_data }} entries

					<span v-if="selectedRows.length">
						&nbsp; &nbsp; {{ selectedRows.length }} rows selected
					</span>
				</p>

				<span class="mb-0 ml-4">Rows:</span>

				<!-- <el-select class="select-primary pagination-select mx-2" v-model="pagination.perPage" @change="perPageChanged" placeholder="Per page">
					<el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
						:value="item">
					</el-option>
				</el-select> -->

			</div>
			<base-pagination class="pagination-no-border" :current="proposalPagination.page" :per-page="proposalPagination.limit"
				:total="proposalPagination.total_data" @change="paginationChanged($event)">
			</base-pagination>
		</div>

		<!-- DRAWERS -->
		<PreviewModal ref="preview_modal"></PreviewModal>
		<DrawerFilter ref="filter_initial_proposal_drawer" />
	</div>
</template>
<script>
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
import PreviewModal from '@/components/Modal/PreviewModal'
import DrawerFilter from '@/views/InitialProposal/Drawers/DrawerFilter'
import { Button, Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown, Tooltip, Popover } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import {
	notifyFunctionMixin,
	helperFunctionMixin,
	axios,
	services,
	getHeader,
	debounce,
	swal,
} from '@/assets/js/httpImports.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useInitialProposalStore } from '@/stores/initialProposalStore'
import { useMessagingStore } from '@/stores/messagingStore'
import { BASKET_DESCRIPTION } from '@/assets/js/status.js'
import { BASKET_COLOR } from '@/assets/js/colors.js'


export default {
	props: ['is_loading_table'],
	mixins: [notifyFunctionMixin, helperFunctionMixin, clientPaginationMixin],
	components: {
		MessagingBoxButton,
		BasePagination,
		PreviewModal,
		DrawerFilter,
		[Button.name]: Button,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Tooltip.name]: Tooltip,
		[Popover.name]: Popover,
	},
	data() {
		return {
			filter_status: 'all',
			searchQuery: '',
			propsToSearch: ['psal_customer_id', 'customer_detail.name', 'psal_created_by_detail.name', 'psal_main_status'],
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			searchText: '',
			debouncedHandler: '',
			first_load: true,
			is_loading: false,
			edit_proposal: null,
			pagination: {
				perPage: 50,
				perPageOptions: [5, 10, 25, 50, 100, 500]
			},
			BASKET_DESCRIPTION: BASKET_DESCRIPTION,
			BASKET_COLOR: BASKET_COLOR,
			filters: {
				status: '',
				ssa: '',
				created_by: '',
				credit_mgr: '',
				created_by: '',
				updated_by: '',
			},
		}
	},
	mounted() {
		this.debouncedHandler = debounce(() => {
		}, 1000);
	},
	computed: {
		...mapState(useAuthStore, ['viewable_customer_ids', 'auth_user']),
		...mapState(useInitialProposalStore, ['proposalList','proposalPagination'])
	},
	watch: {
		tableData(newVal) {
			if (newVal) {
				this.pagination.total = newVal.length;
				this.checkActiveDetail();
			}
		},
		proposalList:{
			handler(newVal){
				if(!_gHlp.isEmpty(newVal)){
					this.getProfileListMessagesSummaries('proposal',newVal);
				}
			},
			immediate: true
		}
	},
	async created() {
		// await this.getInitialProposals()
	},
	methods: {
		...mapActions(useInitialProposalStore, ['getProposalList','getProposal','setPerPage','setCurrentPage']),
		...mapActions(useMessagingStore, ['getProfileListMessagesSummaries']),
		async viewProposal(proposal) {
			this.$router.push({ path: '/initialProposalDetails/'+proposal.psal_id });
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		async paginationChanged(page)
		{
			this.is_loading = true;
			history.pushState({}, null, this.$route.path + '?page=' + encodeURIComponent(page))
			this.setCurrentPage(page)
			await this.getProposalList();
			this.is_loading = false;
		},
		async perPageChanged()
		{
			this.is_loading = true;
			this.setCurrentPage(1);
			this.setPerPage(pagination.perPage)
			await this.getProposalList();
			this.is_loading = false;
		},
		getAppendixUrl(item) {
			if (this.isEmpty(item.appendixes)) return false;
			let fileItm = item.appendixes.find((x) => x.papp_type == 'PROPOSAL');
			if (this.isEmpty(fileItm)) return false;
			return fileItm.url;
		},
		getBasketColor(item){
			if(this.isEmpty(item.customer_detail.basket)) return '#73839C';
			return this.BASKET_COLOR[item.customer_detail.basket.basket_color]
		},
		getBasketDescription(item){
			if(this.isEmpty(item.customer_detail.basket)) return '';
			return this.BASKET_DESCRIPTION[item.customer_detail.basket.basket_color]
		},
		checkActiveDetail() {
			if (this.edit_proposal) {
				let foundProposal = this.tableData.find((item) => item.psal_id === this.edit_proposal.psal_id)
				if (foundProposal) {
					this.edit_proposal = foundProposal
				} else {
					this.edit_proposal = null
				}
			}
			if (this.$route.query.active === 'proposal' && this.$route.query.proposal_id && this.first_load) {
				const proposal = this.tableData.find((item) => item.psal_id === parseInt(this.$route.query.proposal_id))
				if (proposal) {
					this.viewProposal(proposal)
				}
				this.first_load = false
			}
		},
		generateSsaColor(code,status) {

			if(status.includes('Rejected') || status.includes('Declined') || status.includes('Canceled')) {
				return 'bg-danger'
			}

			if(status.includes('Submitted') || status.includes('Approved') || status.includes('Accept') || status === 'Converted to Case') {
				return 'bg-success'
			}

			if(status.includes('Appeal')) {
				return 'bg-primary'
			}

			return 'bg-warning'
		},
		generateSsaMgrColor(code, status) {

			if(status.includes('Rejected') || status.includes('Declined') || status.includes('Canceled')) {
				return 'bg-danger'
			}

			if((status.includes('Submitted') || status.includes('Approved') || status.includes('Accept') || status === 'Converted to Case') && status !== 'Submitted to SSA Manager') {
				return 'bg-success'
			}

			if(status.includes('Appeal')) {
				return 'bg-primary'
			}

			return 'bg-warning'
		},
		generateCreditMgrColor(code, status) {

			if(status.includes('Rejected') || status.includes('Declined') || status.includes('Canceled')) {
				return 'bg-danger'
			}

			if((status.includes('Submitted') || status.includes('Approved') || status.includes('Accept') || status === 'Converted to Case') && status !== 'Submitted to Credit Control') {
				return 'bg-success'
			}

			if(status.includes('Appeal')) {
				return 'bg-primary'
			}

			return 'bg-warning'
		},
		generateCreditHeadColor(code, status) {

			if(status.includes('Rejected') || status.includes('Declined') || status.includes('Canceled')) {
				return 'bg-danger'
			}

			if((status.includes('Submitted') || status.includes('Approved') || status.includes('Accept') || status === 'Converted to Case') && status !== 'Submitted to Credit Head') {
				return 'bg-success'
			}

			if(status.includes('Appeal')) {
				return 'bg-primary'
			}

			return 'bg-warning'
		},
		generateCustomerColor(status) {

			if(status === 'Accepted' || status === 'Converted to Case') {
				return 'bg-success'
			}

			if(status.includes('Rejected') || status.includes('Declined') || status.includes('Canceled')) {
				return 'bg-danger'
			}

			if(status.includes('Appeal')) {
				return 'bg-primary'
			}
			
			return 'bg-warning'
		},
		filterProposal(event) {
			this.filters.status = event.status
			this.filters.ssa = event.ssa
			this.filters.created_by = event.created_by
			this.filters.credit_mgr = event.credit_mgr
			this.filters.updated_by = event.updated_by
			this.$emit('filterProposal',this.filters)
		},
		deleteProposal(proposal_id){
            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
					let data = {}
					axios.post(`${services.initial_proposal}proposal/delete/${proposal_id}`,data, { headers: getHeader() })
						.then(res => {
							this.$emit('fetchProposal')
                            this.notifySuccess('<b>Proposal: </b> - Successfully Deleted.')
                            return 
						})
						.catch ( e => {
							this.errorFunction(e)
					});
                }
            })
    },
		customProductSort(a,b) {
			const numberA = Number(a.product_applications.length)
			const numberB = Number(b.product_applications.length)
			const res = numberA !== numberB ? numberA - numberB : a - b
			return res
		},
		customSsaMgrSort(a,b) {
			const name1 = a.psal_approved_ssa_by_detail ? a.psal_approved_ssa_by_detail.name.toUpperCase() : 'zzzz'
			const name2 = b.psal_approved_ssa_by_detail ? b.psal_approved_ssa_by_detail.name.toUpperCase() : 'zzzz'
			return name1.localeCompare(name2, 'en', { sensitivity: 'base' }) || 0;
		},
		customCreditMgrSort(a,b) {
			const name1 = a.psal_approved_cc_by_detail ? a.psal_approved_cc_by_detail.name.toUpperCase() : 'zzzz'
			const name2 = b.psal_approved_cc_by_detail ? b.psal_approved_cc_by_detail.name.toUpperCase() : 'zzzz'
			return name1.localeCompare(name2, 'en', { sensitivity: 'base' }) || 0;
		},
		customCreditHeadSort(a,b) {
			const name1 = a.psal_approved_ch_by_detail ? a.psal_approved_ch_by_detail.name.toUpperCase() : 'zzzz'
			const name2 = b.psal_approved_ch_by_detail ? b.psal_approved_ch_by_detail.name.toUpperCase() : 'zzzz'
			return name1.localeCompare(name2, 'en', { sensitivity: 'base' }) || 0;
		},
		customCustomerSort(a,b) {
			const name1 = a.customer_detail ? a.customer_detail.name.toUpperCase() : 'zzzz'
			const name2 = b.customer_detail ? b.customer_detail.name.toUpperCase() : 'zzzz'
			return name1.localeCompare(name2, 'en', { sensitivity: 'base' }) || 0;
		},
		customCreatedBySort(a,b) {
			const name1 = a.psal_created_by_detail ? a.psal_created_by_detail.name.toUpperCase() : 'zzzz'
			const name2 = b.psal_created_by_detail ? b.psal_created_by_detail.name.toUpperCase() : 'zzzz'
			return name1.localeCompare(name2, 'en', { sensitivity: 'base' }) || 0;
		},
		customTatSort(a, b) {
			const numberA = Number(a.tat_summary.tat_stop_at ? a.tat_summary.tat_total : (a.tat_summary.remain_day === null ? -9999 : a.tat_summary.remain_day))
			const numberB = Number(b.tat_summary.tat_stop_at ? b.tat_summary.tat_total : (b.tat_summary.remain_day === null ? -9999 : b.tat_summary.remain_day))
			const res = numberA !== numberB ? numberA - numberB : a - b
			return res
		},
		customSettlementSort(a,b) {
			const numberA = parseFloat(a.summary_ccris_track.total_inv_settlement) +
							parseFloat(a.summary_ccris_track.total_merchant_settlement) +
							parseFloat(a.summary_ccris_track.total_other_settlement)
			const numberB = parseFloat(b.summary_ccris_track.total_inv_settlement) +
							parseFloat(b.summary_ccris_track.total_merchant_settlement) +
							parseFloat(b.summary_ccris_track.total_other_settlement)
			const res = numberA !== numberB ? numberA - numberB : a - b
			return res
		}
	}
}
</script>